import React from 'react';
import {
  Filter as FilterAdmin,
  TextInput,
  SelectInput,
  ReferenceInput,
  AutocompleteInput,
} from 'react-admin';

import { STATUS_ATIVO } from '../../utils';

const choices = [
  { id: 'nao-exposto', name: 'Não Exposto' },
  { id: 'unica', name: 'Única' },
  { id: 'duplicada', name: 'Duplicado' },
  { id: 'triplicada', name: 'Triplicado' },
  { id: 'mais-de-3', name: 'Mais de 3' },
];

const Filter = (props) => (
  <FilterAdmin {...props}>
    <TextInput label="Descrição" source="nome" />
    <SelectInput
      source="exposicao"
      choices={choices}
      label="Exposição"
      allowEmpty={false}
    />
    <ReferenceInput
      fullWidth
      label="Endereço"
      source="endereco_exposicao_produto_id"
      reference="enderecos_exposicao_mercadorias"
      sort={{ field: 'codigo', order: 'ASC' }}
      filterToQuery={(searchText) => ({ nome: `${searchText}` })}
      perPage={10}
      allowEmpty={false}
      filter={{ status: STATUS_ATIVO, terreo_exposicao: true }}
    >
      <AutocompleteInput optionText="codigo" />
    </ReferenceInput>
  </FilterAdmin>
);

export default Filter;
